export default {
    navigationBarTitleText: '协议',
};
